<!--
   Created by qing on 2019/12/31 11:39 上午
   Des: 看板视图分组中field显示值
-->
<template>
  <div class="field-show-data-container" v-if="showData.showData === 0 || showData.showData">
    <div
      class="field-show-data-content"
      v-if="showData.type === types.FORM_ITEM__SINGLE_LINE
      || showData.type === types.FORM_ITEM__SERIAL_NUMBER
       || showData.type === types.FORM_ITEM__PHONE
       || showData.type === types.FORM_ITEM__EXTERNAL_DATA_SOURCE">
      <div
        @click="e => onClickStr(e, showData.showData)"
        class="field-show-data-content"
        :class="{'string-content' : lineFeed}"
        v-html="content(showData.showData)"
      ></div>
    </div>
    <div
      class="field-show-data-content"
      v-if="showData.type === types.FORM_ITEM__MULTILINE">
      <div
        v-if="lineFeed"
        class="field-show-data-content string-content"
        style="white-space: pre-line"
        @click="e => onClickStr(e, showData.showData)"
        v-html="content(showData.showData)">
      </div>
      <div
        v-else
        @click.stop="() => {}"
        class="field-show-data-content" v-html="content(showData.showData)">
      </div>
    </div>
    <div
      class="field-show-data-content"
      v-if="showData.type === types.FORM_ITEM__CASCADE">
      {{showData.showData.value}}
    </div>
    <div v-if="showData.type === types.FORM_ITEM__SINGLE_CHOOSE
      || showData.type === types.FORM_ITEM__DROPDOWN" class="choose-show-content-wrapper">
      <div
        v-if="showData.showColor"
        class="single-choose-show-content"
        :style="{backgroundColor: fetchOption(showData.showData).color}">
        <div>
          {{fetchOption(showData.showData) ? fetchOption(showData.showData).optionName : showData.showData}}
        </div>
      </div>
      <div v-else>
        {{fetchOption(showData.showData) ? fetchOption(showData.showData).optionName : showData.showData}}
      </div>
    </div>
    <div v-if="showData.type === types.FORM_ITEM__NUMBER">
      <span>{{showData.tp === 'YES' ? formatTp(showData.showData) : showData.showData}}{{showData.showUnit}}</span>
    </div>
    <div v-if="showData.type === types.FORM_ITEM__CURRENCY">
        <span>
          {{showData.currencyType === 'RMB' ? '￥' : '$'}}
        </span>
      <span>{{showData.tp === 'YES' ? formatTp(showData.showData) : showData.showData}}</span>
    </div>
    <div v-if="showData.type === types.FORM_ITEM__YES_NO">
      <span>{{showData.showAsCheckbox ? showData.showData ? '是' : '否' : showData.showData ? showData.openText : showData.closeText}}</span>
    </div>
    <div v-if="showData.type === types.FORM_ITEM__GRADE">
      <span>{{showData.showData}}</span>
    </div>
    <div v-if="showData.type === types.FORM_ITEM__SLIDING_BLOCK">
      <span>{{`${showData.showData}%`}}</span>
    </div>
    <div v-if="showData.type === types.FORM_ITEM__DATE">
      <div class="field-show-data-content">
        {{actionFormatDate(showData.showData, showData.formatStr) || `无`}}
      </div>
    </div>
    <div v-if="showData.type === types.FORM_ITEM__CHECKBOX" class="choose-show-content-wrapper">
      <template v-if="showData.showColor">
        <div
          v-for="item in showData.showData.slice(0, 3)"
          :key="item"
          v-if="fetchOption(item)"
          class="single-choose-show-content"
          :style="{backgroundColor: fetchOption(item).color}">
          <div>
            {{fetchOption(item).optionName}}
          </div>
        </div>
        <span v-if="showData.showData.length > 3">...</span>
      </template>
      <div v-else>
        <span v-for="item in showData.showData" :key="item" v-if="fetchOption(item)">
          {{fetchOption(item).optionName}}
        </span>
      </div>
    </div>
    <div v-if="showData.type === types.FORM_ITEM__IMAGE_CHOOSE">
      <span
        v-for="item in showData.showData"
        :key="item">
          {{item}}
      </span>
    </div>
    <div v-if="showData.type === types.FORM_ITEM__IMAGE">
      <el-image
        v-for="item in showData.showData.slice(0, showImageCount)"
        :key="Math.random()"
        :src="item.imgUrl"
        :preview-src-list="showData.showData.map(img => img.imgUrl)"
        fit="cover"
        style="width: 30px; height: 30px; margin-left: 3px; display: inline-block; border: 1px solid #e6e6e6;">
      </el-image>
      <span v-if="showData.showData.length > showImageCount">...</span>
    </div>

    <div v-if="showData.type === types.FORM_ITEM__ATTACHMENT" style="display: flex; flex-wrap: wrap;">
      <div class="file__icon" v-for="file in showData.showData.slice(0, showImageCount)">
        <svg class="icon" aria-hidden="true">
          <use :xlink:href="actionFileType2FileImage(file.fileType)"></use>
        </svg>
      </div>
      <span v-if="showData.showData.length > showImageCount">...</span>
    </div>

    <div v-if="showData.type === types.FORM_ITEM__DATE_RANGE">
      <span>
        {{actionFormatDate(showData.showData[0], showData.dateType === 0 ? `yyyy-MM-dd` : `yyyy-MM-dd HH:mm:ss`)}}
      </span>
      <span v-if="showData.showData && showData.showData.length">-</span>
      <span>
        {{actionFormatDate(showData.showData[1], showData.dateType === 0 ? `yyyy-MM-dd` : `yyyy-MM-dd HH:mm:ss`)}}
      </span>
    </div>
    <div v-if="showData.type === types.FORM_ITEM__ADDRESS">
      <span>
        {{`${showData.showData.province} ${showData.showData.city} ${showData.showData.county} ${showData.showData.detailAddress}`}}
      </span>
    </div>
    <div v-if="showData.type === types.FORM_ITEM__LOCATION">
      <span>
        {{[showData.showData.province, showData.showData.city, showData.showData.county, showData.showData.detailAddress].join('')}}
      </span>
    </div>
    <div v-if="showData.type === types.FORM_ITEM__MEMBER">
      <template v-if="memberShowType === 'NAME'">
        <span>
          {{userList.map(user => user.nickname).join('、')}}
        </span>
      </template>
      <template v-else>
        <el-avatar
          v-for="user in userList.slice(0, 1)"
          :key="user.userId"
          icon="el-icon-s-custom"
          :src="user.headImg"
          size="small"
          style="margin-right: 5px; cursor: pointer; border: 1px solid #e6e6e6;">
        </el-avatar>
        <span v-if="userList.length > 1">...</span>
      </template>
    </div>
    <div v-if="showData.type === types.FORM_ITEM__DEPARTMENT">
      <el-avatar
        v-for="dep in depList.slice(0, 1)"
        :key="dep.depId"
        size="small"
        style="margin-right: 5px; cursor: pointer; font-size: 10px;">
        {{dep.depName}}
      </el-avatar>
      <span v-if="depList.length > 1">...</span>
    </div>
    <div
      v-if="showData.type === types.FORM_ITEM__RELATE_RECORD"
      class="relate-content-wrapper">
      <span
        v-for="item in showData.showData.showTitleList"
        :key="item.instanceId"
        class="relate-show-content">
        {{item.title}}
      </span>
    </div>
    <div
      v-if="showData.type === types.FORM_ITEM__ARCHIVE"
      class="relate-content-wrapper">
      <el-tag
        v-if="showData.showData === 'YES'"
        type="success"
        size="small">
        已归档
      </el-tag>
      <el-tag
        v-if="showData.showData === 'NO'"
        type="warning"
        size="small">
        未归档
      </el-tag>
    </div>
    <div
      v-if="showData.type === types.FORM_ITEM__FORM_RUN_STATUS"
      class="relate-content-wrapper">
      <el-tag
        v-if="showData.showData === 'RUNNING'"
        type="warning"
        size="small">
        进行中
      </el-tag>
      <el-tag
        v-if="showData.showData === 'REJECT'"
        type="danger"
        size="small">
        已拒绝
      </el-tag>
      <el-tag
        v-if="showData.showData === 'FINISH'"
        type="success"
        size="small">
        流转完成
      </el-tag>
    </div>
    <div
      v-if="showData.type === types.FORM_ITEM__FLOW_DETAIL_INFO"
      class="relate-content-wrapper">

      <div
        class="field-show-data-content">
        {{showData.showData.map(item => item.stepName).join('、')}}
      </div>

    </div>
  </div>
</template>

<script>
  import FormSet from "../RyForm"
  import {
    fileType2FileImage,
    formatDate,
    formatNum,
    isPhone,
    isURL,
    selectPhoneNumberAndUrl
  } from "../../assets/js/Untis"

  export default {
    props: {
      showData: Object,
      memberShowType: {
        type: String,
        default: ''
      },
      // 是否换行
      lineFeed: {
        type: Boolean,
        default: false
      },
      showImageCount: {
        type: Number,
        default: 1
      }
    },
    data() {
      return {
        types: FormSet.TYPES
      };
    },
    computed: {
      userList() {
        if (!this.showData.showData) {
          return []
        }
        const userMap = this.$store.getters.userListMap
        const leaveMemberListMap = this.$store.getters.leaveMemberListMap
        const extList = this.$store.getters.extMap
        const leaveExternalMap = this.$store.getters.leaveExternalMap

        let userArr = []
        this.showData.showData.member.forEach(userId => {
          let user = userMap[userId]
          if (user) {
            userArr.push(user)
          } else {
            user = leaveMemberListMap[userId]
            if (user) {
              userArr.push({
                userId: user.userId,
                userName: user.nickname,
                headImg: user.headImg
              })
            }
          }
        })
        this.showData.showData.external.forEach(userId => {
          let user = extList[userId]
          if (user) {
            userArr.push({
              userId: user.userId,
              userName: user.orgUserName,
              nickname: user.orgUserName,
              headImg: user.headImg
            })
          } else {
            user = leaveExternalMap[userId]
            if (user) {
              userArr.push({
                userId: user.userId,
                userName: user.orgUserName,
                nickname: user.orgUserName,
                headImg: user.headImg
              })
            }
          }
        })

        return userArr
      },
      depList() {
        if (!this.showData.showData) {
          return []
        }
        let depMap = this.$store.getters.depListMap
        let depArr = []
        this.showData.showData.depart.forEach(depId => {
          let dep = depMap[depId]
          if (dep) {
            depArr.push(dep)
          }
        })
        return depArr
      }
    },
    methods: {
      actionFileType2FileImage(fileType) {
        return fileType2FileImage(fileType)
      },
      content(val) {
        const value = selectPhoneNumberAndUrl(val)
        return value || ''
      },
      onClickStr(e, str) {
        if (isPhone(str) || isURL(str)) {
          e.stopPropagation()
        }
      },
      fetchOption(optName) {
        if (optName === '其他') {
          return null
        }
        if (optName.startsWith('其他_other_')) {
          const filterField = this.showData.options.filter(opt => opt.id === '其他')[0]
          return {
            color: filterField ? filterField.color : '',
            id: optName,
            optionName: `其他:${optName.substring(9, optName.length)}`
          }
        }
        const filterField = this.showData.options.filter(opt => opt.id === optName)[0]
        return filterField || {optionName: optName, color: '#63B2EE'}
      },
      actionFormatDate(d, formatter) {
        return formatDate(d)(formatter)
      },
      formatTp(value) {
        return formatNum(value)
      }
    }
  };
</script>

<style lang="less">

  .field-show-data-container {
    height: 30px;

    span {
      font-size: 12px;
    }

    .file__icon {
      .icon {
        width: 30px;
        height: 30px;
        vertical-align: -0.15em;
        fill: currentColor;
        overflow: hidden;
        margin-right: 5px;
      }
    }

    .field-show-data-content {
      /*display: inline-block;*/
      /*line-height: 30px;*/
      white-space: nowrap;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 12px;
    }

    .string-content {
      word-wrap: break-word;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
      white-space: normal;
    }

    .choose-show-content-wrapper {
      display: flex;

      .single-choose-show-content {
        padding: 4px 6px;
        margin: 3px 8px 2px 0;
        border-radius: 10px;
        max-width: 100%;
        font-size: 12px;
        height: 20px;
        display: flex;
        align-items: center;
        color: #fff;

        > div {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .relate-content-wrapper {

      .relate-show-content {
        margin-left: 3px;
        background-color: #e6e6e6;
        padding: 3px 5px;
        border-radius: 5px;
        color: #333333;
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
      }
    }
  }

  .show-data-attachment-popper {
    .el-form-item {
      margin-bottom: 0;
    }

    .el-form {
      label {
        width: 80px;
        color: #99a9bf;
        float: left;
      }
    }

    .el-form-item {
      margin-right: 0;
      margin-bottom: 0;

      a {
        word-break: break-all;
        cursor: pointer;
      }
    }
  }
</style>
